<template>
  <TaskDetail
    :taskId="taskId"
    class="content-block"
    @done="onDone"
    @back="onBack"
  ></TaskDetail>
</template>

<script>
import TaskDataMixin from 'CORE/mixins/task-data'
import TaskDetail from 'CORE/components/task/detail'
import { get } from 'lodash'

export default {
    name: 'TaskDetailView',
    components: {
        TaskDetail,
    },
    mixins: [
        TaskDataMixin,
    ],
    props: {
        rootFilter: {
            required: false,
            default: _ => {},
            type: Object,
        },
    },
    computed: {
        taskId() {
            return this.$route.params.id
        },
    },
    methods: {
        onDone() {
            const backProjectId = get(this.$route.query, 'backProjectId', false)
            if (backProjectId) {
                this.$router.push({ name: 'projectsDetail', params: { id: backProjectId } })
            } else {
                this.$router.push({ name: 'tasksList', params: { status: '$all' } })
            }
        },
        onBack() {
            window.history.back(1)
        },
    },
}
</script>
